import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CumulativeLifeInsurance icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CumulativeLifeInsurance } from '@sravni/design-system-icons'
 *
 * <CumulativeLifeInsurance />
 * ```
 */
var CumulativeLifeInsurance = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CumulativeLifeInsurance", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.736 9.182c0 4.54-3.413 8.787-8 9.818-4.587-1.031-8-5.277-8-9.818V5.615A2 2 0 0 1 3.98 3.764l5-2.046a4.637 4.637 0 0 1 3.514 0l5 2.046a2 2 0 0 1 1.243 1.85v3.568Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M9.77 13.273V6.728h2.747c.966 0 1.75.732 1.75 1.636 0 .904-.784 1.636-1.75 1.636M12.514 10H8.463M12.1 12H8.462", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CumulativeLifeInsurance };
//# sourceMappingURL=CumulativeLifeInsurance.js.map
